import {
  useState,
  useEffect,
  useRef,
} from 'react';
import classNames from 'classnames/bind';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);
const maxText = 90;
const maxTextCheck = 110;

const ClassParticularsCell = (props) => {
  const { value = '' } = props;
  const descHolderRef = useRef();
  const [isShowMore, setIsShowMore] = useState(false);

  const handleOutSideClick = (e) => {
    if (descHolderRef?.current && !descHolderRef?.current.contains(e.target)) {
      setIsShowMore(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOutSideClick, false);
    return () => {
      document.removeEventListener('click', handleOutSideClick);
    };
  }, []);

  const toggleExpand = () => {
    setIsShowMore(!isShowMore);
  };

  const hasShowMore = value.length > maxTextCheck;

  return (
    <div className={Styles.particulars_desc_holder} ref={descHolderRef}>
      <div className={cx('particulars_desc')}>
        {hasShowMore ? `${value.substr(0, maxText)}...` : value}
        {hasShowMore && (
          <>
            &nbsp;
            <div className={Styles.particulars_desc_show} onClick={toggleExpand}>
              Show More
            </div>
          </>
        )}
      </div>
      {isShowMore && (
        <div className={cx('particulars_desc_modal')}>
          {value}
          <div className={Styles.particulars_desc_show} onClick={toggleExpand}>
            Show Less
          </div>
        </div>
      )}
    </div>
  );
};

export default ClassParticularsCell;
